import i18n from "homeland/i18n";

require("./emoji-modal");
require("./notifier");

// 嵌入论坛自动 SSO
const ssoAutologin = require("./sso_autologin").init();

const AppView = Backbone.View.extend({
  el: "body",
  repliesPerPage: 50,
  windowInActive: true,

  events: {
    "click a.likeable": "likeable",
    "click a.button-block-user": "blockUser",
    "click a.button-follow-user": "followUser",
    "click a.button-block-node": "blockNode",
    "click a.rucaptcha-image-box": "reLoadRucaptchaImage",
    "click .topics .topic": "visitTopic",
  },

  initialize() {
    let needle;
    this.initForDesktopView();
    this.initComponents();
    this.initScrollEvent();
    this.initInfiniteScroll();
    this.initCable();
    this.restoreHeaderSearchBox();

    if (
      ((needle = $("body").data("controller-name")),
      ["topics", "replies"].includes(needle))
    ) {
      window._topicView = new TopicView({ parentView: this });
    }

    return (window._tocView = new TOCView({ parentView: this }));
  },

  initComponents() {
    $("abbr.timeago").timeago();

    // Bind Ctrl+Enter for submit
    $(".cell_comments_new textarea").unbind("keydown");
    $(".cell_comments_new textarea").bind(
      "keydown",
      "ctrl+return",
      function (el) {
        if ($(el.target).val().trim().length > 0) {
          $(el.target).parent().parent().submit();
        }
        return false;
      }
    );

    $(window).off("blur.inactive focus.inactive");
    $(window).on("blur.inactive focus.inactive", this.updateWindowActiveState);

    // Likeable Popover
    return $("a.likeable[data-count!=0]").tooltipster({
      content: "Loading...",
      theme: "tooltipster-shadow",
      side: "bottom",
      maxWidth: 230,
      interactive: true,
      contentAsHTML: true,
      triggerClose: {
        mouseleave: true,
      },
      functionBefore(instance, helper) {
        const $target = $(helper.origin);
        if ($target.data("remote-loaded") === 1) {
          return;
        }

        const likeable_type = $target.data("type");
        const likeable_id = $target.data("id");
        const data = {
          type: likeable_type,
          id: likeable_id,
        };
        return $.ajax({
          url: "/likes",
          data,
          success(html) {
            if (html.length === 0) {
              $target.data("remote-loaded", 1);
              instance.hide();
              return instance.destroy();
            } else {
              instance.content(html);
              return $target.data("remote-loaded", 1);
            }
          },
        });
      },
    });
  },

  initForDesktopView() {
    if (App.mobile !== false) {
      return;
    }

    // CommentAble @ 回复功能
    return App.mentionable(".cell_comments_new textarea");
  },

  likeable(e) {
    if (!App.isLogined()) {
      location.href = "/account/sign_in";
      return false;
    }

    const $target = $(e.currentTarget);
    const likeable_type = $target.data("type");
    const likeable_id = $target.data("id");
    let likes_count = parseInt($target.data("count"));

    const $el = $(
      `.likeable[data-type='${likeable_type}'][data-id='${likeable_id}']`
    );

    if ($el.data("state") !== "active") {
      $.ajax({
        url: "/likes",
        type: "POST",
        data: {
          type: likeable_type,
          id: likeable_id,
        },
      });

      likes_count += 1;
      $el.data("count", likes_count);
      this.likeableAsLiked($el);
    } else {
      $.ajax({
        url: `/likes/${likeable_id}`,
        type: "DELETE",
        data: {
          type: likeable_type,
        },
      });
      if (likes_count > 0) {
        likes_count -= 1;
      }
      $el
        .data("state", "")
        .data("count", likes_count)
        .attr("title", "")
        .removeClass("active");
      if (likes_count === 0) {
        $("span", $el).text("");
      } else {
        $("span", $el).text(`${likes_count} ${i18n.t("common.likes")}`);
      }
    }
    $el.data("remote-loaded", 0);
    return false;
  },

  likeableAsLiked(el) {
    const likes_count = el.data("count");
    el.data("state", "active")
      .attr("title", i18n.t("common.unlike"))
      .addClass("active")
      .addClass("animate");
    return $("span", el).text(`${likes_count} ${i18n.t("common.likes")}`);
  },

  initCable() {
    if (!window.notificationChannel && App.isLogined() && App.cable) {
      return (window.notificationChannel = App.cable.subscriptions.create(
        "NotificationsChannel",
        {
          connected() {
            return this.subscribe();
          },

          received: (data) => {
            return this.receivedNotificationCount(data);
          },

          subscribe() {
            console.log("NotificationsChannel.subscibe");
            return this.perform("subscribed");
          },
        }
      ));
    }
  },

  receivedNotificationCount(json) {
    // console.log 'receivedNotificationCount', json
    const span = $(".notification-count span");
    const link = $(".notification-count a");
    let new_title = document.title.replace(/^\(\d+\) /, "");
    if (json.count > 0) {
      span.show();
      new_title = `(${json.count}) ${new_title}`;
      const url = App.fixUrlDash(`${App.root_url}${json.content_path}`);
      $.notifier.notify("", json.title, json.content, url);
      link.addClass("new");
    } else {
      span.hide();
      link.removeClass("new");
    }
    span.text(json.count);
    return (document.title = new_title);
  },

  restoreHeaderSearchBox() {
    const $searchInput = $(".header .form-search input");

    if (location.pathname !== "/search") {
      return $searchInput.val("");
    } else {
      // 用 URLSearchParams 正确还原 GET 搜索关键词中的空格
      const q = new URLSearchParams(window.location.search).get("q");
      return $searchInput.val(q);
    }
  },

  followUser(e) {
    const btn = $(e.currentTarget);
    const userId = btn.data("id");
    const span = btn.find("span");
    const followerCounter = $(
      `.follow-info .followers[data-login="${userId}"] .counter`
    );
    if (btn.hasClass("active")) {
      $.ajax({
        url: `/${userId}/unfollow`,
        type: "POST",
        success(res) {
          if (res.code === 0) {
            btn.removeClass("active");
            span.text(i18n.t("common.follow_user"));
            return followerCounter.text(res.data.followers_count);
          }
        },
      });
    } else {
      $.ajax({
        url: `/${userId}/follow`,
        type: "POST",
        success(res) {
          if (res.code === 0) {
            btn.addClass("active").attr("title", "");
            span.text(i18n.t("common.unfollow_user"));
            return followerCounter.text(res.data.followers_count);
          }
        },
      });
    }
    return false;
  },

  blockUser(e) {
    const btn = $(e.currentTarget);
    const userId = btn.data("id");
    const span = btn.find("span");
    if (btn.hasClass("active")) {
      $.post(`/${userId}/unblock`);
      btn
        .removeClass("active")
        .attr("title", i18n.t("common.block_user_title"));
      span.text(i18n.t("common.block_user"));
    } else {
      $.post(`/${userId}/block`);
      btn.addClass("active").attr("title", "");
      span.text(i18n.t("common.unblock_user"));
    }
    return false;
  },

  blockNode(e) {
    const btn = $(e.currentTarget);
    const nodeId = btn.data("id");
    const span = btn.find("span");
    if (btn.hasClass("active")) {
      $.post(`/nodes/${nodeId}/unblock`);
      btn
        .removeClass("active")
        .attr("title", i18n.t("common.block_node_title"));
      span.text(i18n.t("common.block_node"));
    } else {
      $.post(`/nodes/${nodeId}/block`);
      btn.addClass("active").attr("title", "");
      span.text(i18n.t("common.unblock_node"));
    }
    return false;
  },

  reLoadRucaptchaImage(e) {
    const btn = $(e.currentTarget);
    const img = btn.find("img:first");
    const currentSrc = img.attr("src");
    img.attr("src", currentSrc.split("?")[0] + "?" + new Date().getTime());
    return false;
  },

  updateWindowActiveState(e) {
    const prevType = $(this).data("prevType");

    if (prevType !== e.type) {
      switch (e.type) {
        case "blur":
          this.windowInActive = false;
          break;
        case "focus":
          this.windowInActive = true;
          break;
      }
    }

    return $(this).data("prevType", e.type);
  },

  initInfiniteScroll() {
    return $(".infinite-scroll .item-list").infinitescroll({
      nextSelector: ".pagination .next a",
      navSelector: ".pagination",
      itemSelector: ".topic, .notification-group",
      extraScrollPx: 200,
      bufferPx: 50,
      localMode: true,
      loading: {
        finishedMsg: '<div style="text-align: center; padding: 5px;">EOF</div>',
        msgText:
          '<div style="text-align: center; padding: 5px;">Loading...</div>',
        img: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
      },
    });
  },

  initScrollEvent() {
    $(window).off("scroll.navbar-fixed");
    $(window).on("scroll.navbar-fixed", this.toggleNavbarFixed);
    return this.toggleNavbarFixed();
  },

  toggleNavbarFixed(e) {
    const top = $(window).scrollTop();
    if (top >= 50) {
      $(".header.navbar").addClass("navbar-fixed-active");
    } else {
      $(".header.navbar").removeClass("navbar-fixed-active");
    }

    if ($(".navbar-topic-title").length === 0) {
      return;
    }
    if (top >= 50) {
      return $(".header.navbar").addClass("fixed-title");
    } else {
      return $(".header.navbar").removeClass("fixed-title");
    }
  },

  visitTopic(e) {
    const { target, currentTarget } = e;
    if (target.tagName === "A" || target.tagName === "IMG") {
      return;
    }
    currentTarget.querySelector(".title a").click();
  },
});

// Patch for auto dark mode
function getTheme() {
  let preference = $("meta[name='theme']").attr("content");

  if (preference === "auto") {
    if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
      return "dark";
    } else {
      return "light";
    }
  }

  return preference;
}

function switchTheme() {
  let theme = getTheme();
  document.documentElement.setAttribute("data-theme", theme);
}

// iframe到父窗口 postMessage 的 targetOrigin 解析
let __parentOriginWarned = false;
function resolveParentOrigin() {
  const origin = document.body.dataset.parentOrigin;
  if (origin) return origin;
  if (!__parentOriginWarned) {
    console.warn(
      "[homeland] data-parent-origin 未配置，postMessage 回退到 targetOrigin='*'。" +
        "生产环境必须配置（layout 中 <body data-parent-origin='<adam origin>'>），" +
        "否则消息可被同源任意页面接收，存在泄漏风险。"
    );
    __parentOriginWarned = true;
  }
  return "*";
}

const mediaDark = window.matchMedia("(prefers-color-scheme: dark)");
mediaDark.addEventListener("change", () => {
  switchTheme();
});

document.addEventListener("turbolinks:load", () => {
  window._appView = new AppView();
  switchTheme();

  // 嵌入自动 SSO：稳定页生成新 pageId 并上报状态（no-op 时零行为）
  ssoAutologin.onStableLoad();

  let navbar_toggle = document.getElementById("navbar-toggler");
  if (navbar_toggle) {
    navbar_toggle.addEventListener("click", (event) => {
      let navmenu = document.getElementById("main-navbar");
      if (navmenu) {
        navmenu.classList.toggle("main-navbar-open");
      }
    });
  }

  if (window.self !== window.top) {
    const parentOrigin = resolveParentOrigin();
    window.parent.postMessage(
      {
        type: "HOMELAND_NAV",
        source: "homeland",
        // 嵌入导航协议版本：主站据此识别论坛支持 v2 行为
        //（ADAM_NAVIGATE 指令导航 / HOMELAND_NAV_BACK），旧主站忽略该字段
        navVersion: 2,
        path: window.location.pathname + window.location.search,
        href: window.location.href,
      },
      parentOrigin
    );

    rewriteForumLinksForEmbed();

    // 搜索结果页：恢复上次离开时的滚动位置
    restoreSearchScroll();
  }
});

document.addEventListener("turbolinks:click", (event) => {
  if (event.target.getAttribute("href").charAt(0) === "#") {
    return event.preventDefault();
  }
});

// Turbolinks 导航期间强制即时滚动，避免 smooth 导致视觉跳动
document.addEventListener("turbolinks:before-render", () => {
  document.documentElement.style.scrollBehavior = "auto";
});
document.addEventListener("turbolinks:load", () => {
  requestAnimationFrame(() => {
    document.documentElement.style.scrollBehavior = "";
  });
});

// iframe 场景下登出拦截
document.addEventListener(
  "click",
  (e) => {
    const link = e.target.closest?.(
      'a[data-method="delete"][href*="/account/sign_out"]'
    );
    if (!link) return;

    // 仅在 iframe 嵌入场景下拦截；独立访问走 Devise 原生 DELETE 登出
    if (window.self === window.top) return;

    // 捕获阶段抢断：阻止 UJS 冒泡监听器收到事件
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // 通知 Adam 父窗口触发主站登出
    const parentOrigin = resolveParentOrigin();
    window.parent.postMessage(
      { type: "ADAM_SSO_LOGOUT", source: "homeland" },
      parentOrigin
    );
  },
  true
);

// Adam 主站嵌入模式下的历史与导航协调。
// v2 协议能力标记：收到父窗口 ADAM_CAPABILITY 声明（或 ADAM_NAVIGATE 指令）
// 后置 true。旧主站不发送这些消息，以下 v2 行为保持关闭，沿用旧版
// push 历史 / 原生返回，保障单侧发布时功能不回归：
//   - turbolinks visit 转 replace（不写 iframe 历史）
//   - 嵌入链接 href 改写（悬停 URL 指向主站）
//   - 帖子返回按钮 HOMELAND_NAV_BACK
// 标记挂在 window 上（turbolinks 内部导航不重载 JS，跨页面保留），
// topics.js 的 backToTopics 读取同一标记。
window.__adamEmbedNavV2 = false;
let __tlReplaceVisitUrl = null;
document.addEventListener("turbolinks:before-visit", (event) => {
  if (window.self === window.top) return;
  if (!window.__adamEmbedNavV2) return;
  const url = event.data && event.data.url;
  if (!url) return;
  if (__tlReplaceVisitUrl === url) {
    // 本次 visit 已是 replace 转发，放行
    __tlReplaceVisitUrl = null;
    return;
  }
  event.preventDefault();
  __tlReplaceVisitUrl = url;
  Turbolinks.visit(url, { action: "replace" });
});

// 提交搜索前去除首尾空格，避免 GET 编码产生多余的 + 号
document.addEventListener(
  "submit",
  (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute("action") || "";
    if (action.split("?")[0].replace(/\/+$/, "") !== "/search") return;
    form.querySelectorAll('input[name="q"]').forEach((input) => {
      input.value = input.value.trim();
    });
  },
  true
);

// 搜索表单为 GET 提交，Turbolinks 5 不拦截表单提交（默认整页导航会写
// 历史）。嵌入场景下转为 Turbolinks replace 访问（仅 v2 主站）
document.addEventListener(
  "submit",
  (event) => {
    if (window.self === window.top) return;
    if (!window.__adamEmbedNavV2) return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if ((form.getAttribute("method") || "get").toLowerCase() !== "get") return;
    const action = form.getAttribute("action") || window.location.pathname;
    const actionPath = action.split("?")[0].replace(/\/+$/, "");
    if (actionPath !== "/search") return;
    event.preventDefault();
    const params = new URLSearchParams(new FormData(form));
    const query = params.toString();
    Turbolinks.visit(query ? `/search?${query}` : "/search", {
      action: "replace",
    });
  },
  true
);

// Adam 主站 → iframe：历史变化后的指令导航（replace 访问，不写历史）。
// 同时作为 v2 能力协商入口：收到 ADAM_CAPABILITY 声明即启用 v2 嵌入行为
window.addEventListener("message", (event) => {
  if (window.self === window.top) return;
  if (event.source !== window.parent) return;
  const parentOrigin = resolveParentOrigin();
  if (parentOrigin !== "*" && event.origin !== parentOrigin) return;
  const data = event.data;
  if (!data || data.source !== "adam") return;
  if (data.type === "ADAM_CAPABILITY" || data.type === "ADAM_NAVIGATE") {
    if (!window.__adamEmbedNavV2) {
      window.__adamEmbedNavV2 = true;
      // 页面加载时能力声明可能晚于 turbolinks:load 到达，补跑链接改写
      rewriteForumLinksForEmbed();
    }
  }
  if (data.type !== "ADAM_NAVIGATE") return;
  if (typeof data.path !== "string" || !data.path.startsWith("/")) return;
  Turbolinks.visit(data.path, { action: "replace" });
});


// Adam 嵌入模式下的链接 href 改写
const ADAM_COMMUNITY_BASE = "/workbench/community";
const ADAM_FORUM_HREF_ATTR = "data-adam-forum-href";

function adamCommunityUrlForPath(path) {
  if (/^\/topics\/\d+(?:[?#].*)?$/.test(path))
    return `${ADAM_COMMUNITY_BASE}${path}`;
  if (path.startsWith("/search")) return `${ADAM_COMMUNITY_BASE}${path}`;
  return null;
}

function isUjsActionLink(link) {
  return link.hasAttribute("data-method") || link.hasAttribute("data-remote");
}

function rewriteForumLinksForEmbed() {
  if (window.self === window.top) return;
  // 旧主站不改写（悬停 URL 保持论坛地址，点击走 iframe 内原生导航）
  if (!window.__adamEmbedNavV2) return;
  const origin = resolveParentOrigin();
  if (!origin || origin === "*") return;
  document.querySelectorAll('a[href^="/"]').forEach((link) => {
    if (link.hasAttribute(ADAM_FORUM_HREF_ATTR)) return;
    if (isUjsActionLink(link)) return;
    const href = link.getAttribute("href");
    const adamUrl = adamCommunityUrlForPath(href);
    if (!adamUrl) return;
    link.setAttribute(ADAM_FORUM_HREF_ATTR, href);
    link.setAttribute("href", `${origin}${adamUrl}`);
  });
}

document.addEventListener(
  "click",
  (e) => {
    if (window.self === window.top) return;
    const link = e.target.closest?.(`a[${ADAM_FORUM_HREF_ATTR}]`);
    if (!link) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0)
      return;
    e.preventDefault();
    e.stopPropagation();
    Turbolinks.visit(link.getAttribute(ADAM_FORUM_HREF_ATTR), {
      action: "replace",
    });
  },
  true
);

const SEARCH_SCROLL_KEY = "homeland_search_scroll";

// 滚动位置缓存键：关键词 + 页码（同关键词翻页时不交叉恢复）
function searchScrollKeyParams() {
  const params = new URLSearchParams(window.location.search);
  return { q: params.get("q"), page: params.get("page") || "1" };
}

function saveSearchScroll() {
  if (window.location.pathname !== "/search") return;
  try {
    sessionStorage.setItem(
      SEARCH_SCROLL_KEY,
      JSON.stringify({
        ...searchScrollKeyParams(),
        y: window.scrollY,
      })
    );
  } catch (e) {
    /* sessionStorage 不可用时忽略 */
  }
}

function restoreSearchScroll() {
  if (window.location.pathname !== "/search") return;
  try {
    const saved = JSON.parse(
      sessionStorage.getItem(SEARCH_SCROLL_KEY) || "null"
    );
    const current = searchScrollKeyParams();
    if (
      saved &&
      saved.q === current.q &&
      saved.page === current.page &&
      typeof saved.y === "number" &&
      saved.y > 0
    ) {
      // 整页加载恢复滚动时强制即时滚动，避免 smooth 动画
      const html = document.documentElement;
      html.style.scrollBehavior = "auto";
      window.scrollTo(0, saved.y);
      requestAnimationFrame(() => {
        html.style.scrollBehavior = "";
      });
    }
  } catch (e) {
    /* sessionStorage 不可用时忽略 */
  }
}

// iframe 离开搜索页时保存位置，整页切换由 pagehide 兜底
document.addEventListener("turbolinks:before-visit", (event) => {
  if (window.self === window.top) return;
  // 被 v2 导航拦截的 visit 不是真实离开，跳过以避免覆盖正确的滚动位置
  if (event.defaultPrevented) return;
  saveSearchScroll();
});
window.addEventListener("pagehide", () => {
  if (window.self === window.top) return;
  saveSearchScroll();
});

switchTheme();
